import {AccessesBySection, UserRoleEnum} from '@/model/enums/UserRoleEnum';
import { RouteRecordRaw } from 'vue-router';
import { TextRoutesEnum } from './TextRoutesEnum';

const TextPage  = () => import(
    /* webpackChunkName: "Text-module" */ 
    '../pages/Text/TextPage.vue'
);

const TextListPage  = () => import(
    /* webpackChunkName: "Text-module" */ 
    '../pages/TextList/TextListPage.vue'
);

const routes:  Array<RouteRecordRaw> = [];

// Only add /text route if not disabled by env var
if (process.env.VUE_APP_DISABLE_SEND_TEXT_MENU !== 'true') {
    routes.push({
        path: '/text',
        name: TextRoutesEnum.SEND_TEXT,
        component: TextPage,
		meta	 : {
            tabTitle: 'Send Text',
			breadCrumbItems: [
				{label: 'Send Text'},
			],
            roles: AccessesBySection.SEND_TEXT
		}
    });
}

routes.push({
    path: '/text-list',
    name: TextRoutesEnum.SENT_TEXTS,
    component: TextListPage,
    meta	 : {
        tabTitle: 'Text list',
        breadCrumbItems: [
            {label: 'Text List'},
        ],
        roles: AccessesBySection.TEXT_LIST
    }
});

export { routes };
export { TextRoutesEnum };
